import { Observable } from 'rxjs';

export abstract class DeliveryRepositoryPort {
  abstract generateDocument(qualityControlId: string): Observable<Blob>;
}
